import { Controller } from "@hotwired/stimulus";
import { isPwa, getPushSubscriptionEndpoint } from "helpers/pwa_utils";

export default class extends Controller {
  static targets = ["pwaField", "pushEndpointField"];
  static values = {
    override: Boolean, // allow overriding in test env during specs
  };

  async connect() {
    // Do this first so that we don't set either value until this async info comes in
    const subEndpoint = await getPushSubscriptionEndpoint();

    if (this.overrideValue) {
      // hacky workaround until we get real installed-app tests
      this.pushEndpointFieldTarget.value = "https://fake-endpoint.example.com";
      this.pwaFieldTarget.value = true;
    } else {
      this.pushEndpointFieldTarget.value = subEndpoint;
      this.pwaFieldTarget.value = isPwa();
    }
  }
}
